import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class BigTitle extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        let withMoreOrAll = '';
        const moreOrAll = content.more || content.all;

        if (moreOrAll) {
            withMoreOrAll = (
                <a href={content.moreUrl} target="_blank" rel="noopener noreferrer">
                    <p className={styles.more}>{moreOrAll}&gt;</p>
                </a>
            );
        }

        return (
            <div className={styles.bigTitleLine}>
                <h2 className={styles.columnTitle}>{content.title}</h2>
                {withMoreOrAll}
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
BigTitle.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
BigTitle.defaultProps = {};

export default BigTitle;
